import { ACTION_TYPES } from './actionTypes'

export const profileAction = (payload) => ({
	type: ACTION_TYPES.PROFILE,
	payload,
})
